module.exports = __webpack_public_path__ + "img/handshakeCard_250x250.6f056ae5.svg";